export const ENUM_IMAGE_TYPE = {
  ID: 'ID',
  SCREENSHOT: 'SCREENSHOT',
  FRONT: 'FRONT',
  BACK: 'BACK',
  CAPTURE: 'CAPTURE',
};

export const ENUM_GALLERY_TYPE = {
  PROFILE: 'PROFILE',
  FANCLUB: 'FANCLUB',
  SNAPSHOT: 'SNAPSHOT',
};
